import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import I18n from "lib/i18n/i18n";
import WorthyApi from "lib/api/worthyApi";
import { getJewelryBoxUserData } from "actions/pendingJewelryBox";
import BaseChatBot from "components/chatBot/baseChatBot";
import { imageUrl, isDefaultPhone } from "helpers/ApplicationHelper";
import MissingDetails from "components/user/missingDetails";
import NoMatch from "components/noMatch";
import { browserHistory } from "react-router";

class JewelryBoxChatBot extends BaseChatBot {
    constructor(props) {
        super(props);
        this.props.getJewelryBoxUserData(this.props.routeParams.id);
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillReceiveProps(newProps) {
        super.componentWillReceiveProps(newProps);
        if (newProps.jewelryBox && newProps.jewelryBox.bundle_state !== "new")
            // TODO: submission
            console.log("go to items page");
        browserHistory.push("/items");
        if (
            newProps.Session &&
            newProps.Session.isLoggedIn &&
            newProps.jewelryBox
        ) {
            if (newProps.Session.userData.id === newProps.jewelryBox.user_id)
                this.setState({ JBReady: true });
            else return (this.noMatch = true);
        }
        if (
            newProps.Session &&
            newProps.Session.isLoggedIn &&
            newProps.Session.userData &&
            isDefaultPhone(newProps.Session.userData.phone)
        )
            return this.setState({ missingDetails: true });
        else this.setState({ missingDetails: false });
        if (
            newProps.Session &&
            newProps.Session.isLoggedIn &&
            !this.CUIPresentedEventFired
        ) {
            this.CUIPresentedEventFired = true;
        }
    }

    get objectId() {
        return this.props.params.id;
    }

    csaImage() {
        return `url(${imageUrl("item/highValueEstimation/roy.png")})`;
    }

    saveLog(message) {
        WorthyApi.jewelryBoxSaveLog(
            this.objectId,
            this.state.conversationVersion,
            message.key,
            message.text,
            message.direction === "1"
        );
    }

    scheduleAppointmentCallback() {
        super.scheduleAppointmentCallback();
    }

    render() {
        if (this.noMatch) return <NoMatch />;
        if (!this.state.JBReady) return null;
        const chatBotClass = "chat-bot-jewelry-box",
            csaClass = "csa-jewelry-box",
            title = I18n.getString(
                "itemPage::estimationReady::whatsNext::titleJewelryBox"
            ),
            errorTemplate = <JewelryBoxChatBot {...this.props} />;
        if (this.state.missingDetails)
            return (
                <MissingDetails
                    missingPhone={true}
                    params={this.props.params}
                />
            );
        else {
            return (
                <div id="jb-chat-bot-container">
                    {super.render(chatBotClass, csaClass, title, errorTemplate)}
                </div>
            );
        }
    }

    renderMessage(message, i) {
        return super.renderMessage(message, i);
    }
}

const chatBotType = "jewelryBox",
    mapStateToProps = (state) => {
        return Object.assign(
            BaseChatBot.mapStateToPropsObject(state, chatBotType),
            {
                Session: state.Session,
                Experiments: state.Experiments,
                jewelryBox: state.PendingJewelryBox,
            }
        );
    },
    mapDispatchToProps = (dispatch) => {
        return bindActionCreators(
            Object.assign(BaseChatBot.mapDispatchToPropsObject(), {
                getJewelryBoxUserData,
            }),
            dispatch
        );
    };

export default connect(mapStateToProps, mapDispatchToProps)(JewelryBoxChatBot);
